import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../../Components/Modal/modal';
import SearchDropdown from '../../../../Components/Dropdown/dropdown';
import CommonTextField from '../../../../Components/TextField/textField';
import CommonDatePicker from '../../../../Components/Datepicker/datepicker';
import dayjs from 'dayjs';

const StatusModal = ({
  isOpen,
  title,
  selectedCount,
  statusOptions,
  defaultStatus,
  onSubmit,
  onClose,
  statusLabel,
  showCloseDate = false,
}) => {
  const [status, setStatus] = useState(defaultStatus);
  const [comment, setComment] = useState('');
  const [closeDate, setCloseDate] = useState(null);

  const mappedStatusOptions = statusOptions.map((statusItem) => ({
    id: String(statusItem.value),
    name: statusItem.label,
  }));

  const selectedStatus = mappedStatusOptions.find(
    (statusItem) => String(statusItem.id) === String(status),
  ) || null;

  useEffect(() => {
    if (!isOpen) return;
    setStatus(defaultStatus);
    setComment('');
    setCloseDate(null);
  }, [defaultStatus, isOpen]);

  const handleSubmit = () => {
    if (!status || !comment.trim()) return;

    const payload = {
      status: Number(status),
      remarks: comment.trim(),
    };

    if (closeDate) {
      payload.date = dayjs(closeDate).format('YYYY-MM-DD');
    }

    onSubmit(payload);
    setComment('');
    setCloseDate(null);
  };

  const dialogBodycontent = (
    <form className="modal-form sr-status-modal status-update-form" onSubmit={(event) => event.preventDefault()}>
      {selectedCount > 1 ? (
        <div className="sr-status-meta">
          <div className="sr-status-meta__card sr-status-meta__card--compact">
            <div className="sr-status-meta__label">No. of Requests Selected</div>
            <div className="sr-status-meta__value">{selectedCount}</div>
          </div>
        </div>
      ) : null}

      <div className="staff-aug-status">
        <SearchDropdown
          label={statusLabel}
          options={mappedStatusOptions}
          value={selectedStatus}
          placeholder="Select"
          dropdownCss="status-dropdown"
          onChange={(event) => setStatus(event.target.value?.id || '')}
        />
      </div>

      {/** Close date field when shown */}
      {typeof showCloseDate !== 'undefined' && showCloseDate ? (
        <div className="staff-aug-status" style={{ marginTop: 12 }}>
          <CommonDatePicker
            label="Close Date"
            placeholder="Choose"
            value={closeDate ? dayjs(closeDate) : null}
            onChange={(value) => setCloseDate(value ? dayjs(value).format('YYYY-MM-DD') : null)}
            displayFormat="DD/MM/YYYY"
          />
        </div>
      ) : null}

      <div className="description-text-field">
        <CommonTextField
          label={(
            <span>
              Comment
              <span className="mandatory-star"> *</span>
            </span>
          )}
          placeholder="Enter..."
          value={comment}
          onChange={(event) => setComment(event.target.value)}
          variant="outlined"
          textCss="requirement-location-field"
          autoFocus={false}
          size="small"
          id="sr-update-status-comment"
          disabled={false}
          multiline
          rows={1}
        />
      </div>
    </form>
  );

  return (
    <FormDialog
      title={title}
      open={isOpen}
      handleClose={onClose}
      button1Action={onClose}
      button2Action={handleSubmit}
      dialogPaperCss="staffing-request-dialog staffing-request-dialog--status"
      dialogBodycontent={dialogBodycontent}
      button1="Cancel"
      button2="Save"
      cancelButtonId="staffing-request-status-cancel"
      submitButtonId="staffing-request-status-submit"
      button2Disabled={!status || !comment.trim()}
    />
  );
};

StatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  selectedCount: PropTypes.number,
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ).isRequired,
  defaultStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  statusLabel: PropTypes.string,
  showCloseDate: PropTypes.bool,
};

StatusModal.defaultProps = {
  selectedCount: 0,
  defaultStatus: '',
  statusLabel: 'Request Status',
  showCloseDate: false,
};

export default StatusModal;
